import { RoleListView } from '../../../components/Role';
import { UserType } from '../../../types';

export function MemberUserRoles() {
  return <RoleListView type={UserType.Member} />;
}
